import React from 'react';
import { Field } from 'redux-form';
import GenericError from '../GenericError';

const AgreementsQmmfConsent = () => (
  <>
    <div name="qmmfConsent" className="row">
      <div className="col col-xs-12">
        <p>
          <strong>Consent Qualifying Money Market Funds (USD QMMF)</strong>: In
          accordance with Dutch regulatory requirements, the uninvested funds in
          your account(s) may be invested in a USD QMMF. Investing in a USD QMMF
          involves certain risks and important characteristics that you should
          carefully consider before proceeding. USD QMMFs are not traditional
          deposit accounts and do not offer principal guarantees. The value of your
          investment in a USD QMMF may fluctuate, and there is a risk that you
          could lose part or all of your initial investment. USD QMMFs are subject
          to various risks, including, but not limited to, market risk, price risk,
          credit risk, interest rate risk, liquidity risk, currency risk,
          geopolitical risk and management risk. TradeStation Europe currently
          intends to cause your uninvested funds to be invested in the USD QMMF
          JPMorgan Liquidity Funds - USD Liquidity LVNAV Fund, whose KID (Key
          Information Document), Prospectus and latest available Annual Report,
          including its investment objective, portfolio overview, performance data,
          risk factors and summary risk indicator, can be found&nbsp;
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://am.jpmorgan.com/se/en/asset-management/liq/products/jpm-usd-liquidity-lvnav-institutional-dist-lu0103813712"
          >
            here
          </a>
          . The USD QMMF seeks to achieve a return in USD in line with prevailing
          money market rates whilst aiming to preserve capital consistent with such
          rates and to maintain a high degree of liquidity. The USD QMMF will invest
          in short-term USD denominated debt securities, deposits with credit
          institutions and reverse repurchase agreements. The USD QMMF may have
          exposure to investments with zero or negative yields in adverse market
          conditions. Additional information relevant to the USD QMMF’s investment
          objectives can be found in the documents available at the link provided
          above. If you are applying for one or more accounts, you acknowledge and
          affirm that you have read and understand all relevant information
          pertaining to the USD QMMF, and that you are making the following election:
        </p>
      </div>
    </div>

    <div className="row">
      <div className="col col-md-12 agreements-acknowledge-error">
        <GenericError name="qmmfError" />
      </div>
    </div>

    <div>
      <div className="col col-xs-12 no-side-padding check-container mb-4">
        <div className="col col-xs-1 no-side-padding check-button">
          <div className="form-group">
            <div className="checkbox agreements-checkbox">
              {/* eslint-disable-next-line */}
              <label htmlFor="qmmfConsentCheck">
                <Field
                  type="checkbox"
                  id="qmmfConsentCheck"
                  name="qmmfConsentAccepted"
                  component="input"
                  value="False"
                />
              </label>
            </div>
          </div>
        </div>
        <div className="col col-xs-11 no-side-padding check-title">
          I (We) consent to the investment of uninvested funds in a USD QMMF.
          This selection is required in order to process your application.
        </div>
      </div>
    </div>
  </>
);

export default AgreementsQmmfConsent;
